import { LoadingIcon } from '../../../../../components/Zen/LoadingIcon';
import styles from './style.m.less';

export const LoadingIndicator = () => (
    <LoadingIcon>
        <g transform="translate(1 3)" fillRule="evenodd">
            <circle cx="7.5" cy="4" r="4" className={styles.head} />
            <path
                d="M15,18 L15,16 C15,13.790861 13.209139,12 11,12 L4,12 C1.790861,12 2.22044605e-16,13.790861 0,16 L0,18"
                className={styles.body}
            />
            <path d="M22 1L16 7L16 2" className={styles.arrow} />
            <path d="M22 1L16 7L21 7" className={styles.arrow} />
        </g>
    </LoadingIcon>
);
